import { z } from 'zod';

/**
 * The Knowledge page's URL search (`patterns/frontend-conventions.md`, 1): which
 * list is shown, the search text and the page number. Anything unexpected falls
 * back to the default, and defaults are left out of the URL.
 */
export const KNOWLEDGE_VIEWS = ['approved', 'not-approved'] as const;
export type KnowledgeView = (typeof KNOWLEDGE_VIEWS)[number];

export interface KnowledgeSearch {
  view?: KnowledgeView | undefined;
  q?: string | undefined;
  page?: number | undefined;
}

const viewSchema = z.enum(KNOWLEDGE_VIEWS).optional().catch(undefined);
const qSchema = z.string().trim().max(200).optional().catch(undefined);
const pageSchema = z.coerce.number().int().min(1).optional().catch(undefined);

export function parseKnowledgeSearch(search: Record<string, unknown>): KnowledgeSearch {
  const view = viewSchema.parse(search['view']);
  const q = qSchema.parse(search['q']);
  const page = pageSchema.parse(search['page']);
  return {
    view: view === 'approved' ? undefined : view,
    q: q === '' ? undefined : q,
    page: page === 1 ? undefined : page,
  };
}

/** The search for a view, search text and page, leaving defaults out. */
export function knowledgeSearch(view: KnowledgeView, q: string, page: number): KnowledgeSearch {
  return {
    ...(view === 'approved' ? {} : { view }),
    ...(q.trim() === '' ? {} : { q: q.trim() }),
    ...(page === 1 ? {} : { page }),
  };
}
